import { render, staticRenderFns } from "./system-variables.vue?vue&type=template&id=1e746ac4&scoped=true&"
import script from "./system-variables.vue?vue&type=script&lang=js&"
export * from "./system-variables.vue?vue&type=script&lang=js&"
import style0 from "./system-variables.vue?vue&type=style&index=0&id=1e746ac4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e746ac4",
  null
  
)

export default component.exports